<template>
    <div id="contenedor-tabla-generica-intranet" class="container-fluid p-0">
         <CNoSeEncontraronResultados v-if="!this.campoRequeridoEsValido(elementos)" :opciones="{ tituloBusqueda: 'Búsqueda en noticias', NombreSeccion: 'Noticias' }"></CNoSeEncontraronResultados>
         <table v-if="this.campoRequeridoEsValido(elementos)"
            class="table borderless table-light table-hover"
            :id="ID"              
            data-toggle="table"
            data-pagination="true"
            data-undefined-text="Sin información"
            data-maintain-selected="true"  
            data-page-size = "5"
            data-page-list="[5,10,20]"
            data-click-to-select="false"
            data-show-toggle="true"
            data-show-pagination-switch="true"
            data-search="true">
            <thead class="thead-light">
                <tr>
                    <!-- <th id="tabla-contenidos-seleccionar-todo" data-halign="center" data-width="5" data-align="center" data-checkbox="true"></th> -->
                    <th data-halign="center" data-width="10" data-align="center" data-field="Folio" data-sortable="true">
                        Folio
                    </th>
                    <th data-halign="center" data-width="10" data-align="center" data-field="Fecha" data-sortable="true">
                        Fecha
                    </th>
                    <th data-halign="center" data-width="20" data-align="center" data-field="Titulo" data-sortable="true">
                        Titulo
                    </th>
                    <th data-halign="center" data-width="40" data-align="center" data-field="Descripcion" data-sortable="true">
                        Descripcion
                    </th>
                    <th data-events="operateEvents" data-width="15" :data-formatter="this.formateadorHTMLAcciones()" data-halign="center" data-align="center">
                        Acciones
                    </th>
                </tr>
            </thead>
        </table>
        <!-- MODAL NOTICIA -->
        <div class="modal align-middle" tabindex="-1" data-backdrop="static" data-keyboard="false"  id="detalles-noticia-intranet">
            <div class="modal-dialog modal-lg modal-dialog-centered">
                <div v-if="this.campoRequeridoEsValido(noticiaSeleccionada)" class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title">Detalles noticia</h5>
                        <button id="btn-cerrar-detalles-noticia-intranet" class="close" data-dismiss="modal"><i class="fas fa-times-circle"></i></button>
                    </div>
                    <div class="modal-body pl-4 pr-4">
                        <div id="titulo-noticia" class="text-right">
                            <h4 v-html="noticiaSeleccionada.Titulo"></h4>
                            <h6>{{ noticiaSeleccionada.Fecha }}</h6>
                        </div>
                        <div id="imagen-noticia">
                            <img style="height: 250px" :src="noticiaSeleccionada.RutaDeAcceso" alt=""/>
                        </div>
                        <div id="contenido-noticia" class="mt-4 text-justify">
                            <h6 v-html="noticiaSeleccionada.DescripcionCompleta"></h6>
                        </div>
                        <div id="acciones-noticias" class="d-flex justify-content-end">
                            <button class="btn btn-primary" @click="descargarArchivoDeNoticia">Descargar</button>
                        </div>
                    </div>             
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import api from '@/../static/js/api'
import comun from "@/../static/js/comun"
import CNoSeEncontraronResultados from '../Comun/CNoSeEncontraronResultados.vue'

export default {
    props: {
        idContenedor: {
            type: Number,
            default: 0
        },
        elementos: {
            type: Array,
            default: () => []
        },
        opciones: {
            type: Object,
            default: () => ({ 
                tituloBusqueda: 'Busqueda en documentos',
                NombreSeccion: 'Documentos'
            })
        },
    },
    components: {
        CNoSeEncontraronResultados: CNoSeEncontraronResultados
    },
    data() {
        return {
            ID: 'tabla-elementos-generico-intranet',
            cargoElementos: false,
            noticiaSeleccionada: null
        }
    },
    methods: {
        descargarArchivoDeNoticia: function() { 
            var a = document.createElement("a");
            document.body.appendChild(a);
            a.href = `${api.conexion}${api.Comun.funcion.DescargarArchivo}?rutaDelArchivo=${this.noticiaSeleccionada.RutaDeArchivo}`
            a.click();
        },
        inicializarTabla: function() { 
            if(!this.cargoElementos) {
                this.$nextTick(() => {
                    $("#" + this.ID).bootstrapTable({  data: this.elementos });      
                    $("#" + this.ID).bootstrapTable('load', this.elementos ); 
                    this.cargoElementos = true;
                });
            }
        },
        mostrarInformacionDeNoticia: async function({ noticia }) {
            this.noticiaSeleccionada = noticia;
            $("#detalles-noticia-intranet").modal('show');
        },
        formateadorHTMLAcciones: () => {
            return [
            '<div>',
                '<button id="ver-noticia-intranet-CCLDOC" type="button" class="btn btn-light btn-sm btn-xs btn-lg btn-md"><i class="fas fa-eye"></i>&nbsp;Ver Noticia</button>',
            '</div>'
            ].join("");
        },
        campoRequeridoEsValido: function(campo) { 
            let esValido = false
            if(typeof campo === 'string' || campo instanceof String) {
                // valida que filtro tipo cadena no sea nula, indefinida y compuestas solo de espacios en blanco o saltos de linea
                if (campo != null && campo != undefined && campo != '' && campo.replace(/\s/g, '').length) {
                    esValido = true;
                }
            }
            else if (typeof campo === 'number' || campo instanceof Number) {
                // valida que filtro tipo numerico no sea nulo, indefinido y que tengan una valor definido valido (diferente a -1)
                if (campo != null && campo != undefined && campo > 0) {
                    esValido = true;
                }
            }
            else if (typeof campo === 'array' || campo instanceof Array) {
                // valida que filtro tipo numerico no sea nulo, indefinido y que tengan una valor definido valido (diferente a -1)
                if (campo != null && campo != undefined && campo.length > 0) {
                    esValido = true;
                }
            }
            else {
                if (campo != null && campo != undefined) {
                    esValido = true;
                }
            }
            return esValido;
        }
    },
    mounted() {
        this.inicializarTabla();
        window.operateEvents = {
            "click #ver-noticia-intranet-CCLDOC": (e,val,row,index) => {
                this.mostrarInformacionDeNoticia({ noticia: row });
            }
        };
    },
    watch: {
        'elementos': async function() {
            this.inicializarTabla();
        }
    }
}
</script>
<style scoped>
#acciones-noticias .btn-primary {
    background-color: black;
}

#acciones-noticias .btn-primary:focus, #acciones-noticias .btn-primary:hover {
    color: #be9a5e;
}

#contenido-noticia {
    max-height: 130px;
    overflow-y: scroll;
    margin-bottom: 2em;
    padding-right: 10px;
}

/* #contenido-noticia {
    max-height: 300px;
    overflow: auto;
} */

#imagen-noticia {
    cursor: pointer;
}

#titulo-noticia h4 {
    font-weight: bold;
    margin-bottom: 0;
}

#titulo-noticia h6 {
    color: gray;
}

#contenedor-tabla-generica-intranet .modal-lg {
    max-width: 50% !important;
    z-index: 9999999999999999999999999999999999999;
}

#contenedor-tabla-generica-intranet .modal-content {
    background-color: #FFFFFF;
    box-shadow: 0px 6px 20px 8px #424242;;
}

#contenedor-tabla-generica-intranet .modal-header {
    background-color: rgb(0, 0, 0);
    border: none;
    color: white;
}

/* #contenedor-tabla-generica-intranet .modal-dialog {
  position: relative;
  top: 40%;
  transform: translateY(-50%);
} */
</style>
<style>
#contenedor-tabla-generica-intranet .form-control {
    background-color: white;
    color: rgb(63, 62, 62);
    border: 1px solid #656161 !important;
    height: 2.5em;
    width: 50vmin;
}

#contenedor-tabla-generica-intranet th {
    background-color: rgb(59, 59, 59) !important;
    color: white;
}

#contenedor-tabla-generica-intranet td {
    background-color: white;
    vertical-align: middle;
}

.borderless td, .borderless th {
    border: none;
    border-bottom: 1px solid #d8d7d7 !important;
}

#contenedor-tabla-generica-intranet .btn-light {
    background-color: white;
    border: 1px solid #4F4949;
    color: #AF9C9C;
    font-size: 2vmin;
}

#contenedor-tabla-generica-intranet .btn-light:hover, #contenedor-tabla-generica-intranet .btn-light:focus {
    background-color: #4F4949;
    border: 1px solid #4F4949;
    color: white;
}

#contenedor-tabla-generica-intranet table {
    table-layout: fixed;
    width: 100%;
    word-wrap:break-word;
}

#contenedor-tabla-generica-intranet .btn-secondary {
    width: 2.5rem;
    background-color: rgb(59, 59, 59);
    color: white;
    padding: 0.3em 0.3em 0.3em 0.3em;
    box-shadow: none;
}

#contenedor-tabla-generica-intranet .dropdown-toggle {
    width: 3.3rem;
    background-color: white;
    color: black;
}

#contenedor-tabla-generica-intranet .pagination > li > a {
    background-color: white;
    color: #121213;
}
</style>


// WEBPACK FOOTER //
// src/components/Intranet/Formatos/CTablaGenerica.vue